import React from 'react'
import {
    RestyledKicker,
    RestyledPlayIcon,
    StyledLive,
    StyledDuration,
} from './KickerPlayButton.styled'
export const kickerPlayButtonName = 'KickerPlayButton'

const iconHeight = 16

export const KickerPlayButton: React.FC<{
    type: 'vod' | 'live' | null
    text: string
    duration?: string
    play: () => void
    playable: boolean
}> = ({ text, duration = '', play, playable, type }) => {
    const durationOrLive =
        type === 'live' ? (
            <StyledLive />
        ) : (
            <StyledDuration iconHeight={iconHeight}>{duration}</StyledDuration>
        )
    return (
        <RestyledKicker
            className={kickerPlayButtonName}
            kickerPosition={'bottomleftinset-herovideo'}
            kickerType="block"
            iconHeight={iconHeight}
            onClick={(e) => {
                // Bubble to follow the link if not playable
                if (!playable) {
                    return
                }
                e.preventDefault()
                play()
            }}
        >
            <RestyledPlayIcon height={iconHeight} />
            <span>{text}</span>
            {durationOrLive}
        </RestyledKicker>
    )
}
KickerPlayButton.displayName = kickerPlayButtonName
